module.exports = __webpack_public_path__ + "static/media/logo-blue.0523ccb1.png";